import {
  Badge,
  Dialog,
  IconButton,
  Typography,
  Divider,
  List,
  ListItemText,
  ListItemButton,
  Tooltip,
  DialogContent,
  Collapse,
  Stack,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { DialogHeader } from "../../auth/components/DialogHeader";
import { DashboardContext } from "../../modules/dashboard/context/DashboardContexProvider";
import { getSeverityByType } from "../../modules/alarms/pages/AlarmsDetails";
import { formatDateAndHour } from "../utils/utils";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SSEAlarm } from "../../modules/dashboard/models/alarm.model";
import { AlarmDetails, SeverityTypesEnum } from "../../modules/alarms/types";
import { alarmsApi } from "../../services/api";

// Interface para os dados do alarme

export interface AlarmNotificationProps {
  code: string;
  usinaName: string;
  alarms: SSEAlarm[];
}

export default function AlarmNotification() {
  const [open, setOpen] = useState(false);
  const [openDetails, setOpenDetails] = useState<string | null>(null);
  const { theme, layout } = useContext(MainContext);
  const { activeAlarms } = useContext(DashboardContext);
  const navigate = useNavigate();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const redirectToAlarmsPage = (alarm: SSEAlarm) => {
    const stringAlarm = alarm.message.split(":")[0]
    navigate(
      `/alarm/details`, {
      state: {
        usinaName: alarm?.usinaName ?? "",
        usinaId: alarm?.usinaId ?? "",
        ug: alarm.ug ?? "",
        area: alarm.area ?? "",
        code: alarm.code ?? "",
        string: stringAlarm && stringAlarm.includes("String") ? stringAlarm : "",
        message: alarm.message ?? ""
      }
    }
    )
    handleClose();
  };

  const handleToggleDetails = (code: string) => {
    setOpenDetails(openDetails === code ? null : code);
  };

  const [alarms, setAlarms] = useState<AlarmDetails[]>([]);

  useEffect(() => {
    mount()
  }, [activeAlarms])

  const mount = async () => {
    try {
      const response = await alarmsApi.getAlarms();
      setAlarms(response.data);
    } catch {
      console.error("Erro ao buscar a matriz de alarmes")
    };
  }

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen} sx={{ padding: "5px" }}>
        <Badge badgeContent={activeAlarms.length} color="error">
          <MdOutlineNotificationsActive
            style={{
              transition: "transform 0.3s ease-in-out",
              color: layout == LayoutsConfig.LayoutOne ? theme.iconsColor : "#FFFFFF",
            }}
          />
        </Badge>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth
      >
        <DialogHeader id="customized-dialog-title" onClose={handleClose}>
          Alarmes das Usinas
        </DialogHeader>
        <DialogContent
          sx={{
            padding: "0px 8px",
          }}
          dividers
        >
          <List>
            {activeAlarms.length > 0 && activeAlarms.map((alarm) => {
              const currentAlarm = alarms.find((matriz) => alarm.code == matriz.code)

              return (
                <div key={alarm.code}>
                  <ListItemButton
                    onClick={() => handleToggleDetails(alarm.code)}
                    sx={{ paddingY: "20px" }}
                  >
                    <ListItemText
                      primary={`${alarm.code} - ${alarm.usinaName}`}
                      secondary={
                        <>
                          <Stack flexDirection="row">
                            <Typography variant="body2">
                              Nº de alarmes notificados:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight="bold"
                              marginLeft="10px"
                            >
                              {alarm.alarms?.length ?? 0}
                            </Typography>
                          </Stack>
                          <Stack
                            direction={{ xs: "column", md: "row" }}
                            marginTop="2px"
                          >
                            <Typography variant="body2">
                              Severidade:
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight="bold"
                              marginLeft={{ md: "10px" }}
                              display="flex"
                              marginTop="1px"
                              sx={{ gap: "8px" }}
                            >
                              <span>{getSeverityByType(alarm.alarms.length > 0 ? alarm.alarms[0].severity ?? SeverityTypesEnum.bland : SeverityTypesEnum.bland)}</span>
                            </Typography>
                          </Stack>
                          {currentAlarm &&
                            <Stack
                              direction={{ xs: "column", md: "row" }}
                              marginTop="2px"
                            >
                              <Typography variant="body2">
                                {currentAlarm.name}
                              </Typography>
                            </Stack>
                          }
                        </>
                      }
                    />
                    {openDetails === alarm.code ? <ExpandLess /> : <ExpandMore />}
                    <Divider sx={{ backgroundColor: "#FFFFFF" }} />
                  </ListItemButton>
                  <Collapse
                    in={openDetails === alarm.code}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {alarm.alarms?.length > 0 && alarm.alarms.map((alarm) => (
                        <div key={alarm.id}>
                          <Divider sx={{ backgroundColor: "#FFFFFF" }} />
                          <ListItemButton
                            sx={{ pl: 4 }}
                            onClick={() => {
                              redirectToAlarmsPage(alarm);
                            }}
                          >
                            <ListItemText
                              primary={
                                <>
                                  {alarm.code} - {alarm.usinaName} - {alarm.ug} -{" "}
                                  {alarm.area}
                                </>
                              }
                              secondary={
                                <>
                                  <Typography>
                                    Horário:{" "}
                                    {formatDateAndHour(alarm.date) ??
                                      "Não informado"}
                                  </Typography>
                                  <Tooltip title={alarm.message} arrow>
                                    <Typography
                                      component="div"
                                      variant="body2"
                                      sx={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {alarm.message}
                                    </Typography>
                                  </Tooltip>
                                </>
                              }
                            />
                          </ListItemButton>
                        </div>
                      ))}
                    </List>
                  </Collapse>
                </div>
              )
            })}
          </List>
        </DialogContent>
      </Dialog>
    </>
  );
}